import { useContext } from "react";
import { LoginContext } from "./LoginContextProvider";

const useLoginContext = () => useContext(LoginContext);

export default useLoginContext;
